import React from 'react';
import Advertisements from '../Advertisements/Advertisements';
import Banner from '../Banner/Banner';
import Categories from '../BikeCategory/Categories';
import InfoCards from '../InfoCards/InfoCards';



const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <hr className='mt-5'></hr>
            <Advertisements></Advertisements>
            <Categories></Categories>
            <InfoCards></InfoCards>
        </div>
    );
};

export default Home;